module.exports = __webpack_public_path__ + "img/scene2.e7996b7d.png";